import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    CHATBOT_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: CHATBOT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/chatbot',
        component: lazy(() => import('src/views/chatBotIA/chatBotList')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: CHATBOT_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/chatbot/:id',
        component: lazy(() => import('src/views/chatBotIA/chatBotDetails')),
    },
];
